(() => {
  const initialize = (root) => {
    if (root.dataset.collectionReady === 'true') return;
    root.dataset.collectionReady = 'true';
    const form = root.querySelector('[data-collection-sort]');
    if (form) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const url = new URL(window.location.href);
        const sort = form.elements.sort_by.value;
        if (sort) url.searchParams.set('sort_by', sort);
        else url.searchParams.delete('sort_by');
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }
    const controls = root.querySelector('[data-category-controls]');
    if (!controls) return;
    const buttons = Array.from(controls.querySelectorAll('[data-category]'));
    const items = Array.from(root.querySelectorAll('[data-product-category]'));
    const headings = Array.from(root.querySelectorAll('[data-product-group]'));
    const status = root.querySelector('[data-collection-count]');
    const empty = root.querySelector('[data-category-empty]');
    const categories = new Set(buttons.map((button) => button.dataset.category));
    buttons.forEach((button) => {
      const category = button.dataset.category;
      const count = category === 'all' ? items.length : items.filter((item) => item.dataset.productCategory === category).length;
      button.querySelector('[data-category-count]').textContent = String(count);
      button.disabled = count === 0;
      button.hidden = count === 0;
    });
    const applyCategory = (category, updateAddress = false) => {
      if (!categories.has(category) || !items.some((item) => category === 'all' || item.dataset.productCategory === category)) category = 'all';
      let count = 0;
      const visibleGroups = new Set();
      items.forEach((item) => {
        const visible = category === 'all' || item.dataset.productCategory === category;
        item.hidden = !visible;
        if (visible) {
          count += 1;
          visibleGroups.add(item.dataset.itemGroup);
        }
      });
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
      headings.forEach((heading) => { heading.hidden = !visibleGroups.has(heading.dataset.productGroup); });
      status.textContent = root.dataset.countTemplate.replace('__COUNT__', String(count));
      empty.hidden = count !== 0;
      if (updateAddress) {
        const url = new URL(window.location.href);
        url.hash = category === 'all' ? '' : `category=${category}`;
        window.history.replaceState(null, '', url);
      }
    };
    const categoryFromAddress = () => new URLSearchParams(window.location.hash.slice(1)).get('category') || 'all';
    buttons.forEach((button) => button.addEventListener('click', () => applyCategory(button.dataset.category, true)));
    window.addEventListener('hashchange', () => applyCategory(categoryFromAddress()));
    controls.hidden = false;
    applyCategory(categoryFromAddress());
  };
  const initializeWithin = (scope) => scope.querySelectorAll('[data-caisson-collection]').forEach(initialize);
  initializeWithin(document);
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
